<div class="component-container flex flex-col xs:p-[2rem] sm:p-[1rem] md:p-[2.7rem]">
  <div
    class="table-section"
  >
    <mat-expansion-panel
      [expanded]="expandPanel"
      class="mat-elevation-z0 expansion-panel min-w-full"
    >
      <mat-expansion-panel-header
        class="bg-black-100 expansion-panel-header justify-center"
      >
        <div class="flex justify-between w-full h-full items-center flex-row">
          <div class="flex items-center w-[40%] title">
            Notifications
          </div>
          <div class="drop-down-section flex items-center w-[60%] flex justify-end">
            <app-dropdown
              (click)="onClickDropDown($event)"
              [controlName]="'filters'"
              [enableClearSelection]="true"
              [options]="filterOptions"
              [parentFormGroup]="form"
              class="filter-drop-down md:w-[50%] w-[70%]"
              placeholder="Select one"
              type="small"
            />
            <div class="delete-icon-wrapper">
              <app-icon
                (click)="deleteSelectedNotification($event)"
                [svgIcon]="'delete'"
                class="icon"
              >
              </app-icon>
            </div>
          </div>
        </div>
      </mat-expansion-panel-header>
      <div (scrolled)="onScroll()"
           [infiniteScrollDistance]="2"
           [infiniteScrollThrottle]="10"
           [scrollWindow]="false"
           class="table-wrapper overflow-auto xs:h-[calc(100vh-18rem)] sm:h-[calc(100vh-18rem)] md:h-[calc(100vh-20rem)]"
           infiniteScroll
      >
        <table
          (matSortChange)="sortData($event)"
          [class.hidden]="loading && !notificationList.length"
          [dataSource]="notificationList"
          mat-table
          matSort
        >
          <ng-container
            [sticky]="true"
            matColumnDef="selected"
          >
            <th
              *matHeaderCellDef
              class="checkbox-heading w-[3%]"
              mat-header-cell
            >
              <mat-checkbox (change)="selectedAllCheckboxClicked($event)"
                            [(checked)]="allSelection"
                            [(indeterminate)]="allIndeterminate"
                            class="checkbox header-checkbox"/>
            </th>
            <td
              (click)="getNotificationDetails(eachRow)"
              *matCellDef="let eachRow;let index=index"
              class="checkbox-body w-[3%]"
              mat-cell
            >
              <div class="t-cell">
                <div
                  class="notification-content">
                  <mat-checkbox (click)="onCheckboxClicked($event,eachRow,index)"
                                [checked]="eachRow.selected"
                                class="checkbox"/>
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container
            [sticky]="true"
            matColumnDef="title"
          >
            <th
              *matHeaderCellDef
              class="min-w-[10rem] md:min-w-[25rem]"
              mat-header-cell
            >
              <div class="th-cell header-checkbox">
                Title
              </div>
            </th>
            <td
              (click)="getNotificationDetails(eachRow)"
              *matCellDef="let eachRow;let index=index"
              mat-cell
            >
              <div class="td-cell">
                <div [class.unread]="!eachRow.read"
                     class="notification-content">
                  {{eachRow.title}}
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container
            matColumnDef="createdAt"
          >
            <th
              *matHeaderCellDef
              class="min-w-[15rem]"
              mat-header-cell
              mat-sort-header
              id="createdAt"
            >
              <div class="th-cell notification-title header-checkbox">
                Date
              </div>
            </th>
            <td (click)="getNotificationDetails(eachRow)"
                *matCellDef="let eachRow"
                mat-cell>
              <div [class.unread]="!eachRow.read"
                   class="td-cell notification-content notification-title">
                {{eachRow.createdAt | date}}
              </div>
            </td>
          </ng-container>
          <ng-container
            matColumnDef="message"
          >
            <th
              *matHeaderCellDef
              class="min-w-[25rem]"
              mat-header-cell
            >
              <div class="th-cell notification-title header-checkbox">
                Message
              </div>
            </th>
            <td (click)="getNotificationDetails(eachRow)"
                *matCellDef="let eachRow"
                mat-cell>
              <div class="td-cell notification-content notification-title">
                <div [class.unread]="!eachRow.read"
                     [innerHTML]=" eachRow.message"
                ></div>

              </div>
            </td>
          </ng-container>
          <tr *matHeaderRowDef="notificationDisplayColumn"
              mat-header-row></tr>
          <tr *matRowDef="let row; columns: notificationDisplayColumn;"
              mat-row></tr>
        </table>
        <div *ngIf="loading"
             [ngClass]="{ 'initial': !notificationList?.length }"
             class="table-loader w-full flex justify-center items-center">
          <mat-spinner/>
        </div>
        <div
          *ngIf="!loading && !notificationList?.length"
          class="no-data flex flex-col justify-center items-center"
        >
          <div class="text">
            No data matching the filter.
          </div>
        </div>
      </div>

    </mat-expansion-panel>
  </div>
</div>
